import { useTranslation } from 'react-i18next';
import { ResponseResult } from 'lavva.exalushome/build/js/Services/FieldChangeResult';
import { UpdateErrorCode } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { useBackdropContext } from '../../../../context/backdrop';
import { toastError, toastInfo } from '../../../../utils/toast';
import { updateErrorCodeMap } from '../../modules/controller-settings/utils/controller';

export const useUpdateErrors = () => {
  const { t } = useTranslation('device-info');
  const { turnOffBackdrop } = useBackdropContext();

  const showUpdateError = (data: ResponseResult<UpdateErrorCode>, responseMessage?: boolean) => {
    turnOffBackdrop();

    const error = updateErrorCodeMap[data.Type as keyof typeof updateErrorCodeMap];
    if (!error) return;

    const message = t(`exalus.updateResult.${error.key}`);
    if (responseMessage) {
      return { message, icon: error.icon };
    } else {
      if (data.Type === UpdateErrorCode.DeviceIsUpToDate) {
        toastInfo({ content: message });
      } else {
        toastError({ content: message });
      }
    }
  };

  const handleUpdatesResponse = <T,>(data: T | ResponseResult<UpdateErrorCode>, onSuccess: () => void) => {
    if (typeof (data as ResponseResult<UpdateErrorCode>).Type === 'number') {
      showUpdateError(data as ResponseResult<UpdateErrorCode>);
    } else {
      onSuccess();
    }
  };

  return {
    handleUpdatesResponse,
    showUpdateError,
  };
};
